import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showDialog(event) {
    event.preventDefault();
    window.print();
  }
}
